import { Paper, Link, Typography } from "@mui/material";
import { makeStyles } from "@mui/styles";
import StableImage from "./StableImage";
import {
  imageScaleAtom,
} from "../state";
import { useRecoilValue } from "recoil";
import { MAX_IMAGE_SIZE } from "../constants";

const useStyles = makeStyles((theme) => ({
  root: {
    padding: theme.spacing(2),
    marginBottom: theme.spacing(1),
    "div:first-child": {
      marginTop: 0,
      paddingTop: 0,
    },
    width: "98%",
  },
  img: {
    width: "auto",
    margin: "0.5em",
    verticalAlign: "top",
  },
  laneTitle: {
    fontSize: "1.5em",
    margin: 0,
  },
  laneHeader: {
    display: "flex",
    justifyContent: "space-between",
  },
}));

const ImageLane = ({ laneTitle, images, onClick, laneControls, titleInteraction, subtitle, readOnly }) => {
  const classes = useStyles();
  const imageScale = useRecoilValue(imageScaleAtom);

  return (
    <Paper
      elevation={3}
      className={classes.root}
      data-testid={`imageLane-${laneTitle}`}
      sx={{
        ...(readOnly &&{
          backgroundColor: "#e6f7ff",
          opacity: 0.9,
        })
      }}
    >
      <div className={classes.laneHeader}>
        <span className={classes.laneTitle}>
          {titleInteraction != null &&
             <Link underline="hover" component="button" variant="h5" onClick={titleInteraction}>{laneTitle}</Link>
          }
          {titleInteraction == null &&
             <Typography variant="h5">{laneTitle}</Typography>
          }
        </span>
        {subtitle}
        {laneControls !== null && laneControls}
      </div>

      {images.map((img) => (
        <StableImage
          img={img}
          onClick={onClick}
          className={classes.img}
          key={img.id}
          height={MAX_IMAGE_SIZE * imageScale/100}
        />
      ))}
    </Paper>
  );
};

export default ImageLane;
